import { Dispatch } from 'react';
import {
  NoteItem,
  NotePaginateList,
  NoteResultListParam,
} from '../types/note-setting';
import { forEach } from 'lodash';
import { getDayEnd, getDayStart } from 'src/app/common/utils';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';

export type UpdateNoteBody = {
  title: string;
  content: string
};

const noteEndpoint = '/simulation/note-setting';

export const fetchNoteResultList = async (
  params: NoteResultListParam,
  sortKeys: { key: string; value?: string }[],
  dispatch?: Dispatch<any>,
): Promise<NotePaginateList> => {
  let queryPath = `${ADMIN_URL}${noteEndpoint}?`;

  forEach(params, (param, key) => {
    if (typeof param === 'object') {
      if (param) {
        if (key.includes('From')) {
          queryPath += `${key}=${getDayStart(param).toISOString()}&`;
        }
        if (key.includes('To')) {
          queryPath += `${key}=${getDayEnd(param).toISOString()}&`;
        }
      }
    } else {
      queryPath += param ? `${key}=${param}&` : '';
    }
  });

  forEach(sortKeys, (sortParams, key) => {
    if (sortParams.value) {
      const sortValue = sortParams.value === 'asc' ? 'ascending' : 'descending';
      if (key === 0) {
        queryPath += `${sortParams.key}=${sortValue}&`;
      } else {
        queryPath += `${sortParams.key}=${sortValue}`;
      }
    }
  });

  if (!queryPath.includes('Sort')) queryPath += `lastUpdateDateSort=descending`;

  return apiClient
    .get<NotePaginateList>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchNoteItem = async (id: string, dispatch?: Dispatch<any>): Promise<NoteItem> => {
  return apiClient
    .get<NoteItem>(`${ADMIN_URL}${noteEndpoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const updateNoteItem = async (
  id: string,
  body: UpdateNoteBody,
  dispatch?: Dispatch<any>,
): Promise<void> => {
  return apiClient
    .put<void>(`${ADMIN_URL}${noteEndpoint}/${id}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
